var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgParagraphIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 2.8125H7.5C6.09104 2.8125 4.73978 3.37221 3.7435 4.3685C2.74721 5.36478 2.1875 6.71604 2.1875 8.125C2.1875 9.53396 2.74721 10.8852 3.7435 11.8815C4.73978 12.8778 6.09104 13.4375 7.5 13.4375H10.3125V16.25C10.3125 16.4986 10.4113 16.7371 10.5871 16.9129C10.7629 17.0887 11.0014 17.1875 11.25 17.1875C11.4986 17.1875 11.7371 17.0887 11.9129 16.9129C12.0887 16.7371 12.1875 16.4986 12.1875 16.25V4.6875H13.4375V16.25C13.4375 16.4986 13.5363 16.7371 13.7121 16.9129C13.8879 17.0887 14.1264 17.1875 14.375 17.1875C14.6236 17.1875 14.8621 17.0887 15.0379 16.9129C15.2137 16.7371 15.3125 16.4986 15.3125 16.25V4.6875H16.25C16.4986 4.6875 16.7371 4.58873 16.9129 4.41291C17.0887 4.2371 17.1875 3.99864 17.1875 3.75C17.1875 3.50136 17.0887 3.2629 16.9129 3.08709C16.7371 2.91127 16.4986 2.8125 16.25 2.8125ZM10.3125 11.5625H7.5C6.58832 11.5625 5.71398 11.2003 5.06932 10.5557C4.42466 9.91102 4.0625 9.03668 4.0625 8.125C4.0625 7.21332 4.42466 6.33898 5.06932 5.69432C5.71398 5.04966 6.58832 4.6875 7.5 4.6875H10.3125V11.5625Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParagraphIcon);
export default __webpack_public_path__ + "static/media/ParagraphIcon.cb3150bde0f4105f49e9b15a42b0536e.svg";
export { ForwardRef as ReactComponent };